import { Box, Button, Grid, Paper, Typography } from "@mui/material"
import { useUser } from "../../../../Hooks/useUser"
import { useNavigate } from "react-router-dom";
import { ProfileType } from "../../../../Types/General";

interface PortfolioSectionProps {
    urls: string[]
}
export const PortfolioSection = ({urls}:PortfolioSectionProps) => {
    /* ******************** Hooks ******************** */
     const { hasPremium, type } = useUser();
     const navigate = useNavigate();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handleUpgrade = () => {
        navigate('/settings/membership?mode=edit')
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid item display={"flex"} flexDirection={"column"} >
            <Typography variant='lora-title-medium' fontWeight={"bold"} marginBottom={'16px'}>Portfolio</Typography>
            {
                hasPremium || type == ProfileType.Talent?
                urls?.map((url, idx) => (
                    <Grid key={url + idx} item display={"flex"} flexDirection={"column"} marginBottom={'16px'}>
                        <Typography key={url} variant='body-medium' marginBottom={0.5}>{url}</Typography>
                    </Grid>
                )) :
                <Paper 
                    elevation={0}
                    sx={{
                        backgroundColor: 'green.50',
                        width: '350px',
                        height: '48px',
                    }} 
                >
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }} 
                    >
                        <Grid display={'flex'} flex={2} flexDirection={'row'}>
                            <Typography variant="body-small" marginLeft={'24px'}>View links that Talents share</Typography>
                        </Grid>
                        <Grid justifyContent={'flex-end'} display={'flex'} flex={1} flexDirection={'row'}>
                            <Button variant="outlined" size="small" sx={{marginRight: '8px'}} onClick={handleUpgrade}>Upgrade</Button>
                        </Grid>
                    </Box>
                </Paper>
            }
        </Grid>
    )
}